import { EntityType } from 'common/enums/entity-enums.js';

export const verticalTablesTypes = [EntityType.ProjectData, EntityType.CoordinateReferenceSystem, EntityType.WellboreWellheadPosition, EntityType.TemperatureDefinition, EntityType.GeomagneticParameters, EntityType.SiteReferenceSystem];

export const isVerticalTable = (type: EntityType) => verticalTablesTypes.includes(type as EntityType);